export default "__VITE_ASSET__CPupr6RH__"